import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import MicroDermalPiercingImage from '../../Assets/Piercing Services/micro dermal piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function MicroDermalPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Micro Dermal Piercing UAE | 500 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Micro Dermal Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Micro Dermal Piercing 500 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={MicroDermalPiercingImage} alt="Micro Dermal Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Micro Dermal Piercing</h3>

          <p>
            Enhance your body art with elegance and precision through our professional micro dermal piercing services in the UAE, available at a premium price of 500 AED. Micro dermal piercing is a subtle and sophisticated surface piercing that places a single decorative element directly into the skin, creating the illusion of a small jewel resting effortlessly on your body. This minimal yet eye-catching style is perfect for individuals who want a delicate touch added to their overall appearance while maintaining a clean and refined aesthetic. Whether placed on the face, chest, neck, or hands, micro dermal piercing offers versatility and creativity, allowing you to express your personal style in a unique and modern way.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each micro dermal piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Dermal piercings require specialized techniques, and our experienced specialists are trained to ensure proper depth, placement, and stability for long-lasting and aesthetically pleasing results while minimizing discomfort.
          </p>

          <p>
            Micro dermal piercing is ideal for individuals who prefer a subtle yet stylish body modification that blends seamlessly with their natural features. Its minimalist design allows it to be worn alone for a simple and elegant look or combined with multiple dermal piercings to create a customized and artistic pattern. With a wide range of jewelry options such as crystals, metallic tops, and decorative designs, you can personalize your piercing to match your style and personality. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry design to suit your aesthetic goals.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic dermal jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that dermal piercings can feel intimidating, especially for first-time clients, and our friendly and experienced staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for micro dermal piercings, and we provide detailed instructions to help you maintain proper care during the healing period. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection, irritation, or displacement. Following proper aftercare is essential for maintaining the longevity and appearance of your piercing.
          </p>

          <p>
            Our micro dermal piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive exceptional value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted micro dermal piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a subtle and elegant body look effortlessly. Book your micro dermal piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Micro Dermal Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MicroDermalPiercing;